import UilAngleDown from '@iconscout/react-unicons/icons/uil-angle-down';
import UilSignout from '@iconscout/react-unicons/icons/uil-signout';
import { Avatar } from 'antd';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Popover } from '../../popup/popup';
import { logOut } from '../../../redux/authentication/actionCreator';
import Cookies from 'js-cookie';
import axios from '../../../backendServiceWithoutTimeout';

const AuthInfo = React.memo(() => {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    flag: 'en',
  });
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState(null);
  const { i18n } = useTranslation();
  const { flag } = state;

  const SignOut = (e) => {
    e.preventDefault();
    dispatch(logOut(() => navigate('/')));
  };
  // Fetch the userId from cookies and use it to get user information from the API
  useEffect(() => {
    const userId = Cookies.get('userId');
    if (userId) {
      getUserInfo(userId); // Fetch user info by passing the userId
    } else {
      console.log('User ID not found in cookies.');
    }
  }, []);

  // Function to call the API and fetch user info based on userId
  const getUserInfo = async (userId) => {
    try {
      // console.log('userId', userId);
      const response = await axios.get(`/users/user-profile/${userId}`);
      setUserInfo(response.data);
      // console.log('data userid is here', response.data);
    } catch (error) {
      console.error('Error fetching user information:', error);
    }
  };
  const userContent = (
    <div>
      <div className="min-w-[250px] sm:min-w-full bg-gradient-to-r from-blue-500 to-indigo-600 rounded-lg shadow-lg p-6">
        {userInfo ? (
          <>
            <div className="text-center mb-4">
              <h3 className="text-xl font-bold text-white">
                <strong>Name:</strong> {userInfo.userName}
              </h3>
              <p className="text-sm text-indigo-100">
                <strong>Email:</strong> {userInfo.email}
              </p>
            </div>
          </>
        ) : (
          <p className="text-center text-indigo-100">Loading user information...</p>
        )}
        <Link
          to="#"
          onClick={SignOut}
          className="flex items-center justify-center mt-6 text-sm font-medium text-indigo-600 bg-white hover:bg-gray-100 rounded-md h-10 transition-all duration-150 shadow-md"
        >
          <UilSignout className="w-4 h-4 mr-2" /> Sign Out
        </Link>
      </div>
    </div>
  );

  const onFlagChangeHandle = (value, e) => {
    e.preventDefault();
    setState({
      ...state,
      flag: value,
    });
    i18n.changeLanguage(value);
  };

  const country = (
    <div className="block bg-white dark:bg-[#1b1d2a]">
      <Link
        to="#"
        onClick={(e) => onFlagChangeHandle('en', e)}
        className="flex items-center bg-white dark:bg-white10 hover:bg-primary-transparent px-3 py-1.5 text-sm text-dark dark:text-white60"
      >
        <img className="w-3.5 h-3.5 ltr:mr-2 rtl:ml-2" src={require('../../../static/img/flag/en.png')} alt="" />
        <span>English</span>
      </Link>
      <Link
        to="#"
        onClick={(e) => onFlagChangeHandle('en', e)}
        className="flex items-center bg-white dark:bg-white10 hover:bg-primary-transparent px-3 py-1.5 text-sm text-dark dark:text-white60"
      >
        <img className="w-3.5 h-3.5 ltr:mr-2 rtl:ml-2" src={require('../../../static/img/flag/esp.png')} alt="" />
        <span>Spanish</span>
      </Link>
      <Link
        to="#"
        onClick={(e) => onFlagChangeHandle('en', e)}
        className="flex items-center bg-white dark:bg-white10 hover:bg-primary-transparent px-3 py-1.5 text-sm text-dark dark:text-white60"
      >
        <img className="w-3.5 h-3.5 ltr:mr-2 rtl:ml-2" src={require('../../../static/img/flag/ar.png')} alt="" />
        <span>Arabic</span>
      </Link>
    </div>
  );

  return (
    <div className="flex items-center justify-end flex-auto">
      <div className="flex ltr:ml-3 rtl:mr-3 ltr:mr-4 rtl:ml-4 ssm:mr-0 ssm:rtl:ml-0">
        <Popover placement="bottomRight" content={userContent} action="click">
          <Link to="#" className="flex items-center text-light whitespace-nowrap">
            <Avatar src="https://cdn0.iconfinder.com/data/icons/user-pictures/100/matureman1-512.png" />
            <UilAngleDown className="w-4 h-4 ltr:md:ml-[5px] rtl:md:mr-[5px]" />
          </Link>
        </Popover>
      </div>
    </div>
  );
});

export default AuthInfo;
